import * as React from 'react';
import { SVGProps } from 'react';

const IconExpandSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9 3H5V1h6v6H9V3zM3 9V5H1v6h6V9H3z"
    />
  </svg>
);
export default IconExpandSizeXs;
